module.exports = __webpack_public_path__ + "79c89fe5d5c7a77e3056e59418a7bf63.woff2";